var $ = jQuery,
    inMotion = false,
    cg_lastPosition = [],
    cg_startPos = 0,
    cg_dragging = false;

function recalcPageDots() {
  $('.mySlider-wrapper').each(function() {
      var num_dots,
          clipWidth,
          slideHolder,
          scrollWidth,
          i,
          dot_container,
          html = '';
      clipWidth = $(this).find('.mySlider-frame').width();
      slideHolder = $(this).find('.mySlider-slidePanel');
      slideHolder.css('left', '0');
      scrollWidth = $(this).find('.mySlider-slidePanel')[0].scrollWidth;
      num_dots = Math.round(scrollWidth / clipWidth);
      dot_container = $(this).find('.pagination-holder');
      if (num_dots > 1) {
          for (i = 0; i < num_dots; i++) {
              html += '<div class="dot' + (i == 0 ? ' active' : '') + '" dot-number="' + i + '"></div>';
          }
      }
      dot_container.html(html);
      $(this).find('.mySlider-leftArrow').css({ 'opacity': '0' });
      if (num_dots > 1) {
          $(this).find('.mySlider-rightArrow').css({ 'opacity': '1' });
      } else {
          $(this).find('.mySlider-rightArrow').css({ 'opacity': '0' });
      }
  });
}

$(document).on('click', '.mySlider-arrow', function() {
    if (inMotion || $(this).css('opacity') !== '1') {
        return;
    }
    var parentCon = $(this).parents('.mySlider-wrapper'),
        dist = parentCon.find('.mySlider-frame').width() + parseInt(parentCon.find('.mySlider-item').css('margin-right')),
        slideHolder = parentCon.find('.mySlider-slidePanel'),
        active = parentCon.find('.dot.active'),
        right = 0;
    if ($(this).hasClass('mySlider-rightArrow')) {
        dist *= -1;
        right = 1;
    }
    inMotion = true;
    slideHolder.animate({
        left: '+=' + dist
    }, 500, function() {
        inMotion = false;
        var pos = slideHolder.position().left,
            wid = slideHolder[0].scrollWidth;
        active.removeClass('active');
        if (right) {
            active.next().addClass('active');
        } else {
            active.prev().addClass('active');
        }
        if (pos < 0) {
            parentCon.find('.mySlider-leftArrow').css({ 'opacity': '1' });
        } else {
            parentCon.find('.mySlider-leftArrow').css({ 'opacity': '0' });
        }
        if (wid + pos > slideHolder.parent().width()) {
            parentCon.find('.mySlider-rightArrow').css({ 'opacity': '1' });
        } else {
            parentCon.find('.mySlider-rightArrow').css({ 'opacity': '0' });
        }
    });
});

$(document).on('click', '.mySlider-wrapper .dot', function() {
    if (inMotion) {
        return;
    }
    var wrapper = $(this).parents('.mySlider-wrapper'),
        dotNumber = parseInt($(this).attr('dot-number')),
        left = dotNumber *
        (wrapper.find('.mySlider-frame').width() +
            parseInt(
                wrapper.find('.mySlider-item').css('margin-right')
            )
        ),
        $this = $(this);


    inMotion = true;
    wrapper.find('.mySlider-slidePanel').animate({
        left: -left
    }, 500, function() {
        inMotion = false;
        wrapper.find('.dot.active').removeClass('active');
        $this.addClass('active');
        wrapper.find('.slider-arrow').css({ 'opacity': '1' });
        if (dotNumber) {
            if (dotNumber === wrapper.find('.dot').length - 1) {
                wrapper.find('.mySlider-rightArrow').css({ 'opacity': '0' });
            }

        } else {
            wrapper.find('.mySlider-leftArrow').css({ 'opacity': '0' });
        }
    });
});

$(document).ready(function () {
    "use strict";
    var sliderFrames = document.getElementsByClassName('mySlider-frame'),
        i;
    
    for (i = 0; i < sliderFrames.length; i++) {
        sliderFrames[i].addEventListener('touchstart', function (evt) {
            "use strict";
        
            // if the slider is still animating from the previous touch, then ignore this event
            if (inMotion) {
                return;
            }
        
            var parentCon = $(this).parents('.mySlider-wrapper'),
                touchPos = {};

            // record the starting touch position and the initial slider position
            cg_lastPosition = [];
            touchPos.x = evt.touches[0].clientX;
            touchPos.y = evt.touches[0].clientY;
            touchPos.time = Date.now();
            cg_lastPosition[0] = touchPos;
            cg_startPos = parseInt(parentCon.find('.mySlider-slidePanel').css('left'), 10);
        }, {passive: true});
        
        sliderFrames[i].addEventListener('touchmove', function (evt) {
            "use strict";
            // if the slider is still in motion from the previous touch, then ignore this event
            if (inMotion) {
                return;
            }

            var parentCon = $(this).parents('.mySlider-wrapper'),
                newPos = {};
        
            newPos.x = evt.touches[0].clientX;
            newPos.y = evt.touches[0].clientY;
            newPos.time = Date.now();
        
            // if the motion is more horizontal than vertical, then start dragging the slider
            if (!cg_dragging && (Math.abs(newPos.x - cg_lastPosition[0].x) - 2 * Math.abs(newPos.y - cg_lastPosition[0].y) > 0)) {
                // generally horizontal motion so enable the carousel
                cg_dragging = true;
            }
        
            // if the slider is being dragged, then update its position relative to the users finger movement
            if (cg_dragging) {
                cg_lastPosition.push(newPos);
                parentCon.find('.mySlider-slidePanel').css({ 'left': (cg_startPos + newPos.x - cg_lastPosition[0].x) });
            }
        }, {passive: true});
        
        sliderFrames[i].addEventListener('touchend', function (evt) {
            "use strict";
            // current position of the slider (controlled by users finger)
            var parentCon = $(this).parents('.mySlider-wrapper'),
                endPos = parseInt(parentCon.find('.mySlider-slidePanel').css('left'), 10),
                // look back in history at the users finger movement to get a position and time
                prevPos = cg_lastPosition[Math.max(cg_lastPosition.length - 5, 0)],
                // get the most recently recorded position of the users finger
                currPos = cg_lastPosition[cg_lastPosition.length - 1],
                // get the amount of time between the historical touch pos and most recent touch pos
                deltaTime = Math.min(prevPos.time - currPos.time, 1),
                // calculate the x velocity of the finger movement (distance over time)
                velocity = (currPos.x - prevPos.x) / deltaTime,
                itemNum, // refers to an index of an item in the carousel
                targetPos, // the left pixel position that the slider will move to
                arrivalTime, // the amount of time over which to animate the slider movement
                itemDistance,
                active;
        
            // if there wasn't a valid touch move detected then ignore this event
            if (!cg_dragging) {
                return;
            }
        
            // update the flags
            cg_dragging = false;
            inMotion = true;
        
            // do some boundary checks - don't let the user drag the slider out of range
            if (endPos > 0) {
                targetPos = 0;
                active = parentCon.find('.dot');
                active.removeClass('active');
                $(active[0]).addClass('active');
            } else if (endPos + parentCon.find('.mySlider-slidePanel')[0].scrollWidth < parentCon.find('.mySlider-frame').width()) {
                targetPos = parentCon.find('.mySlider-frame').width() - parentCon.find('.mySlider-slidePanel')[0].scrollWidth;
                active = parentCon.find('.dot');
                active.removeClass('active');
                $(active[active.length - 1]).addClass('active');
            } else {
                // snap to next item in the current direction
                // itemNum is the item that is cutoff on the left side of the display
                active = parentCon.find('.dot.active');
                itemDistance = parentCon.find('.mySlider-frame').width() + parseInt(parentCon.find('.mySlider-item').css('margin-right'));
                itemNum = Math.floor(-endPos / itemDistance);
                active.removeClass('active');
                if (velocity > 0) {
                    itemNum += 1;
                    active.next().addClass('active');
                } else {
                    active.prev().addClass('active');
                }
        
                // if something went wrong with the math, then adjust it here to make sure nothing breaks
                if (itemNum < 0) {
                    itemNum = 0;
                    active = parentCon.find('.dot');
                    active.removeClass('active');
                    $(active[0]).addClass('active');
                } else if (itemNum > parentCon.find('.mySlider-item').length - 1) {
                    itemNum = parentCon.find('.mySlider-item').length - 1;
                    active = parentCon.find('.dot');
                    active.removeClass('active');
                    $(active[active.length - 1]).addClass('active');
                }
        
                // figure out where we want to end up
                targetPos = (-itemNum * itemDistance);
            }
        
            // figure out how long it should take to get there
            arrivalTime = Math.min(Math.abs((targetPos - endPos) / velocity), 1000);
            parentCon.find('.mySlider-slidePanel').animate({ 'left': targetPos }, arrivalTime, function() {
                inMotion = false;
            });
        }, {passive: true});
    }
});

$(window).resize(recalcPageDots);

$(document).ready(function() {
    recalcPageDots()
});
